import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { ChipModule } from 'primeng/chip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { RippleModule } from 'primeng/ripple';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { Modalidad } from '../../../model/Modalidad';
import { Category } from '../../../model/competitions/Category';
import { Competition, IdObject } from '../../../model/competitions/Competition';
import { CategoryLevel } from '../../../model/competitions/Level';
import { CompetitionType } from '../../../model/competitions/competitionType';
import { RoleService } from '../../../services/role.service';
import { HockeyCompetitionDetailComponent } from "../../event-gestor/modalities/hockey/hockey-competition-detail/hockey-competition-detail.component";
import { HockeyCompetitionFormComponent } from "../../event-gestor/modalities/hockey/hockey-competition-form/hockey-competition-form.component";
import { ArtisticoCompetitionFormComponent } from "../../event-gestor/modalities/artistico/artistico-competition-form/artistico-competition-form.component";
import { CompetitionDetailComponent } from '../competition-detail/competition-detail.component';
import { CompetitionFormComponent } from '../competition-form/competition-form.component';
@Component({
  selector: 'app-competitions-table',
  standalone: true,
  providers: [MessageService, ConfirmationService],
  templateUrl: './competitions-table.component.html',
  styleUrl: './competitions-table.component.scss',
  imports: [
    ChipModule,
    TableModule,
    DialogModule,
    RippleModule,
    ButtonModule,
    ToastModule,
    ToolbarModule,
    ConfirmDialogModule,
    InputTextModule,
    InputTextareaModule,
    CommonModule,
    FileUploadModule,
    DropdownModule,
    TagModule,
    RadioButtonModule,
    RatingModule,
    InputTextModule,
    FormsModule,
    InputNumberModule,
    TooltipModule,
    CompetitionFormComponent,
    CompetitionDetailComponent,
    HockeyCompetitionDetailComponent,
    HockeyCompetitionFormComponent,
    ArtisticoCompetitionFormComponent
],
})
export class CompetitionsTableComponent implements OnInit {
  productDialog: boolean = false;

  @Input()
  competitions!: Competition[];

  @Input()
  categories!: Category[];

  @Input()
  levels!: CategoryLevel[];

  @Input()
  modalidad!: Modalidad;

  @Input()
  events: any[] = [];

  competitionSelected!: Competition;
  submitted: boolean = false;
  statuses!: any[];
  competition!: Competition;
  showCompetitionForm: boolean = false;
  isUpdateCompetition: boolean = false;
  showCompetitionDetail: boolean = false;
  showAdminEventOptions: boolean = false;
  constructor(private roleService: RoleService) {}
  ngOnInit(): void {
    if (this.isEventAdmin()) {
      this.showAdminEventOptions = true;
    }
  }

  isEventAdmin(): boolean {
    return this.roleService.getRoles().includes('SID_EVENT_ADMIN');
  }

  openNew() {
    this.showCompetitionForm = true;
    this.isUpdateCompetition = false;
  }
  onCompetitionCreated(competition: Competition) {
    if (this.competitions.some((c) => c.id === competition.id)) {
      const index = this.competitions.findIndex((c) => c.id === competition.id);
      this.competitions[index] = competition;
    } else {
      this.competitions.push(competition);
    }
  }

  editCompetition(competition: Competition) {
    this.competitionSelected = { ...competition };
    this.isUpdateCompetition = true;
    this.showCompetitionForm = true;
  }

  deleteCompetition(competition: Competition) {
    this.competitionSelected = { ...competition };
  }

  getGategoryDescription(categories: IdObject[]): string {
    let description = '';
    categories.forEach((category, index) => {
      description += this.categories.find((c) => c.id === category.id)?.name;
      if (index < categories.length - 1) {
        description += ', ';
      }
    });
    return description;
  }

  openRegistration(competition: Competition) {
    this.competitionSelected = { ...competition };
    this.showCompetitionDetail = true;
  }

  getCompetitionType(competitionType: CompetitionType): string {
    switch (competitionType) {
      case CompetitionType.EXTERNAL:
        return 'Externos';
      case CompetitionType.MEMBERS:
        return 'Vinculados';
      case CompetitionType.MEMBERS_AND_EXTERNAL:
        return 'Vinculados y Externos';
      default:
        return 'Desconocido';
    }
  }
}
